import { render, staticRenderFns } from "./Riwayat.vue?vue&type=template&id=dcca90a6&scoped=true&"
import script from "./Riwayat.vue?vue&type=script&lang=js&"
export * from "./Riwayat.vue?vue&type=script&lang=js&"
import style0 from "./Riwayat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Riwayat.vue?vue&type=style&index=1&id=dcca90a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcca90a6",
  null
  
)

export default component.exports